import "@js/modules/polyfill";
import "@js/modules/skip-link-focus-fix.js";
import Promise from "es6-promise-promise";
import modernizr from "@js/vendor/modernizr-3.6.0.min.js";
import throttle from "lodash/throttle";
// import debounce   from 'lodash/debounce';
import RM from "@js/vendor/RM";
import Util from "@js/vendor/Util";

import variables from "@js/variables";
import debug from "@js/modules/debug";

// import Barba from 'barba.js'; // TODO ?
// import Highway from 'highway.js'; // TODO ?
// import OfflineSupport from '@js/modules/offline';

// import "@js/modules/wordpress";
import "@js/modules/wordpressAll";
import Cookie from "@js/modules/cookie";
import PageTransition from "@js/modules/pageTransition";
// import PageTransitionAjax from '@js/modules/pageTransitionAjax';
import Pointer from "@js/modules/pointer";
import Smooth from "@js/modules/smoothScroll";

window.Util = Util;
window.debug = debug;
window.throttle = throttle;
// window.debounce     = debounce;
window.variables = variables;
// window.DOMAnimation = DOMAnimation;

const SELECTORS = {
  // loaderTextePercent: '#pageloader .pageloader__text-percent',
  pageloader: "#pageloader",
  loaderProgress: "#pageloader .pageloader__progress",

  linkWords: ".link-words",
  linkLetters: ".link-letters",
  linkUnderline: ".link-underline",

  form: ".form",
  form7: ".wpcf7-form",

  revealScroll: ".reveal-on-scroll",
  plane: ".plane",
  parallax: ".item-parallax:not(.no-instance)",
  slideshow: ".slideshow",
  swiper: ".swiper-container",

  blockGallerySlider: ".wp-block-gallery-wrapper.slider",
};
const CLASSES = {
  loading: "loading",
  loaded: "loaded",
  animation: "fade-in",

  hasScroll: "hasScroll",
  scrollingUp: "scrollingUp",
  scrollingDown: "scrollingDown",
};

// Main App Object
const App = {
  //--- VARS

  // ga_code: 'UA-XXXXXXXX-X',// Use for Ajax navigation
  // cssTags : [],// Use for Ajax navigation

  loadTotal: 0,
  loadProgress: 0,

  modules: [],
  modulesWithScroll: [],
  modulesToInit: [],

  el: {
    html: RM.Dom.html,
    body: RM.Dom.body,
    main: RM.G.id("main"),
    app: RM.G.id("app"),
    header: RM.G.id("site-header"),
  },

  bounds: {
    window_w: 0,
    window_h: 0,
    mainOffsetTop: 0,
    appOffsetTop: 0,
    headerH: 0,
  },

  env: {
    // isIE: navigator.userAgent.indexOf('MSIE ') > 0 || navigator.userAgent.match(/Trident.*rv\:11\./) !== null,
    isIE: RM.Snif.isIE,
    // isMobile: navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) !== null,
    isMobile: RM.Snif.isMobile,

    cssVariablesSupport: window.CSS && CSS.supports("color", "var(--fake-var)"),
    webpSupport: Util.hasClass(document.documentElement, "webp"),
    intersectionObserverSupport:
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype,
    mutationObserverSupport: "MutationObserver" in window,
    idleCallbackSupport: "requestIdleCallback" in window,

    reducedMotion: window.matchMedia("(prefers-reduced-motion)").matches,
  },

  MathUtils: {
    // Equation of a line.
    lineEq: (y2, y1, x2, x1, currentVal) => {
      var m = (y2 - y1) / (x2 - x1),
        b = y1 - m * x1;
      return m * currentVal + b;
    },
    // Linear Interpolation function.
    lerp: (a, b, n) => (1 - n) * a + n * b,
    // Normalisation function
    norm: (value, min, max) => {
      return (value - min) / (max - min);
    },
  },

  // FIRST INIT

  initialize() {
    const t = this;
    Util.addClass(this.el.html, this.env.isIE ? "isIE" : "isNotIE");
    Util.addClass(this.el.html, this.env.isMobile ? "isMobile" : "isNotMobile");
    // Util.removeClass(this.el.html, 'no-js');

    if (!this.env.intersectionObserverSupport) {
      import("intersection-observer");
    }

    // Dimensions
    const windowDim = Util.getWindowDimensions();
    this.bounds.window_w = windowDim.width;
    this.bounds.window_h = windowDim.height;
    this.bounds.mainOffsetTop = this.el.main.offsetTop;
    this.bounds.appOffsetTop =
      this.bounds.mainOffsetTop + this.el.app.offsetTop;
    this.bounds.headerH = this.el.header.offsetHeight;

    this.el.pageloader = RM.Select.query(SELECTORS.pageloader);
    this.el.pageloaderProgress = RM.Select.query(SELECTORS.loaderProgress);

    // Initialize elements
    RM.BM(this, ["onUpdate", "onScroll", "onResize"]);
    // this.Offline = new OfflineSupport(t);
    this.initServiceWorker();
    this.initializeQuicklink();
    this.initResizeEvents();
    this.initScrollEvents();
    // Util.scrollZero();

    this.modules["Cookie"] = new Cookie();
    this.modules["PageTransition"] = new PageTransition();
    // this.modules['PageTransitionAjax'] = new PageTransitionAjax();
    this.modules["Pointer"] = new Pointer();
    this.modules["Smooth"] = new Smooth();
    if (RM.Has(this.modules["Smooth"], "onAppScroll"))
      this.modulesWithScroll.push("Smooth");

    // IE ? Add an alert
    if (this.isIE) {
      const ie_p = document.createElement("p");
      Util.addClass(ie_p, "browserupgrade");
      ie_p.innerHTML =
        'You are using an <strong>outdated</strong> browser. Please <a href="https://browsehappy.com/" target="_blank">upgrade your browser</a> to improve your experience and security.';
      this.el.body.appendChild(ie_p);
    }

    this.copyright();
    this.init();
    requestAnimationFrame(this.onUpdate);
  },

  //--- INITS

  init() {
    // debug('app init');
    const t = this;

    // Reset
    this.loadTotal = 0;
    this.loadProgress = 0;
    this.el.pageloader.style.setProperty("--weight", "100");
    this.el.pageloaderProgress.style.transform = "scaleX(0)";

    // this.Parallax     = null;
    // this.RevealOnScroll = null;
    this.modulesToInit.forEach((mod) => {
      this.modules.splice(mod, 1);
      this.modulesWithScroll = this.modulesWithScroll.filter(
        (value, index, arr) => {
          return value !== mod;
        }
      );
    });
    this.modulesToInit = [];

    //--- Init the page ---
    this.el.app = RM.G.id("app");
    this.initReducedMotion();
    this.initQuicklink();
    this.launchModulesFunc("onAppInit");

    //--- Load modules ---
    // Home page
    // if ( Util.hasClass(this.el.app, 'home') ) {
    // Util.addClass(this.el.body, 'home'); // for the pageloader
    if (Util.hasClass(this.el.body, "home")) {
      this.initProdTotale();
    }

    this.initScrollMoreClick();

    // Admin bar
    if (Util.hasClass(this.el.app, "admin-bar")) {
      Util.addClass(this.el.body, "admin-bar");
      Util.removeClass(this.el.app, "admin-bar");
    }

    // All pages > init scripts if there is at least one
    if (
      RM.Select.el(SELECTORS.linkWords).length ||
      RM.Select.el(SELECTORS.linkLetters).length
    ) {
      import("@js/modules/link").then(function (module) {
        const Link = module.default;
        t.modules["Link"] = new Link();
      });
    }
    if (RM.Select.el(SELECTORS.linkUnderline).length) {
      import("@js/modules/link-underline").then(function (module) {
        const LinkUnderline = module.default;
        t.modules["LinkUnderline"] = new LinkUnderline();
      });
    }
    if (
      RM.Select.el(SELECTORS.form7).length ||
      RM.Select.el(SELECTORS.form).length
    ) {
      import("@js/modules/form").then(function (module) {
        const Form = module.default;
        t.Form = new Form();
      });
    }
    if (RM.Select.query(SELECTORS.parallax) && !this.env.reducedMotion) {
      this.modulesToInit.push("Parallax");
      import("@js/modules/parallax").then(function (module) {
        const Parallax = module.default;
        t.modules["Parallax"] = new Parallax();
        t.modules["Parallax"].initialize();
      });
    }
    if (
      RM.Select.el(SELECTORS.revealScroll).length &&
      !this.env.reducedMotion
    ) {
      this.modulesToInit.push("RevealOnScroll");
      import("@js/modules/revealOnScroll").then(function (module) {
        const RevealOnScroll = module.default;
        t.modules["RevealOnScroll"] = new RevealOnScroll();
        t.modules["RevealOnScroll"].initialize();
      });
    }
    if (RM.Select.el(SELECTORS.plane).length && !this.env.reducedMotion) {
      // this.modulesToInit['PlaneGL'] = 1;
      this.modulesToInit.push("PlaneGL");
      import("@js/modules/planeGL").then(function (module) {
        const PlaneGL = module.default;
        t.modules["PlaneGL"] = new PlaneGL();
        t.modules["PlaneGL"].initialize();
        if (RM.Has(t.modules["PlaneGL"], "onAppScroll"))
          t.modulesWithScroll.push("PlaneGL");
      });
    }
    if (RM.Select.queryAll(SELECTORS.blockGallerySlider).length) {
      this.modulesToInit.push("BlockGallerySlider");
      import("@js/modules/blockGallerySlider").then(function (module) {
        const BlockGallerySlider = module.default;
        t.modules["BlockGallerySlider"] = new BlockGallerySlider();
        t.modules["BlockGallerySlider"].initialize();
      });
    }
    if (RM.Select.el(SELECTORS.swiper).length) {
      this.modulesToInit.push("SwiperSlider");
      import("@js/modules/swiperSlider").then(function (module) {
        const SwiperSlider = module.default;
        t.modules["SwiperSlider"] = new SwiperSlider();
        t.modules["SwiperSlider"].initialize();
      });
    }
    if (RM.Select.el(SELECTORS.slideshow).length) {
      this.modulesToInit.push("Slider");
      import("@js/modules/slideshow").then(function (module) {
        const Slider = module.default;
        t.modules["Slider"] = new Slider();
        t.modules["Slider"].initialize();
      });
    }

    // All pages
    // this.modulesToInit.push('PageLoader');
    // import('@js/modules/pageLoader').then(function (module) {
    //   const PageLoader = module.default;
    //   t.modules['PageLoader'] = new PageLoader();
    // });
    // this.modulesToInit.push('Gallery');
    // import('@js/modules/gallery').then(function (module) {
    //   const Gallery = module.default;
    //   t.modules['Gallery'] = new Gallery();
    //   t.modules['Gallery'].initialize();
    // });
    this.modulesToInit.push("Lightbox");
    import("@js/modules/lightbox").then(function (module) {
      const Lightbox = module.default;
      t.modules["Lightbox"] = new Lightbox();
      t.modules["Lightbox"].initialize();
    });

    // Page Eolien
    if (
      Util.hasClass(this.el.body, "page-id-137") ||
      (Util.hasClass(this.el.body, "page-id-909") && !this.env.isMobile)
    ) {
      import("@js/modules/eolien").then(function (module) {});

      this.modulesToInit.push("PageEolien");
      import("@js/modules/eolien").then(function (module) {
        const PageEolien = module.default;
        t.modules["PageEolien"] = new PageEolien();
        t.modules["PageEolien"].initialize();
        if (RM.Has(t.modules["PageEolien"], "onAppScroll"))
          t.modulesWithScroll.push("PageEolien");
      });
    }

    // this.loadTotal += Object.keys(this.modulesToInit).length
    this.loadTotal += this.modulesToInit.length;

    // // Now, change one (or more) uniform value as we scroll.
    // // The faster the scrolling the more the value changes.
    // let currentScroll = window.pageYOffset
    // let intensity = 0
    // // It will go from 0 (not scrolling) to 0.9 (scrolling at a speed of maxscroll).
    // const maxscroll = 10
    // const uniformValuesRange = [0,0.9]

    // // Using requestAnimationFrame + linear interpolation for the effect.
    // const render = () => {
    //   // Current scroll position
    //   const newScroll = window.pageYOffset
    //   // How much was scrolled from the last repaint.
    //   const scrolled = Math.abs(newScroll - currentScroll)
    //   // Get the new value of volatility.
    //   volatility =  t.MathUtils.lerp( volatility, Math.min( t.MathUtils.lineEq(uniformValuesRange[1], uniformValuesRange[0], maxscroll, 0, scrolled), 0.9 ), 0.05 )
    //   // Set the volatility.
    //   // material.uniforms.uVolatility.value = volatility;

    //   t.el.main.style.transform = 'rotate(' + volatility + 'deg)'

    //   // Update the current scroll.
    //   currentScroll = newScroll
    //   // Repeat.
    //   requestAnimationFrame(render)
    // }
    // requestAnimationFrame(render)
  },

  // Init Resize Events
  initResizeEvents() {
    const t = this;

    this.RO = new RM.RO({
      cb: this.onResize,
      throttleDelay: 200,
    });
    this.RO.on();
  },

  // Init Scroll Events
  // => Scroll Top button
  initScrollEvents() {
    const t = this;

    this.scroll = {
      isScrolling: false,
      target: 0,
      last: 0,
      diff: 0,
      acc: 0,
      velo: 0,
      // ease: this.env.isMobile ? 0.35 : 0.075,
      ease: this.env.isMobile ? 0.35 : 0.1,

      scrollTreshold: 20,
      scrollDirection: false,
    };

    RM.L(
      window,
      "a",
      "scroll",
      throttle((e) => this.onScroll(e), 60)
    );

    // store the hash
    this.targetAnchor = window.location.hash;
    // targetAnchor = targetAnchor.replace('#', '');

    this.targetEl =
      this.targetAnchor !== "" && document.querySelector(this.targetAnchor);

    // Does a scroll target exist?
    if (this.targetEl) {
      // delete hash so the page won't scroll to it
      window.location.hash = "";
    }
  },

  // Init Quicklink
  // => prefetch in-viewport links during idle time
  // https://github.com/GoogleChromeLabs/quicklink
  initializeQuicklink() {
    if (!this.env.intersectionObserverSupport) {
      return;
    }
    const t = this;
    this.el.quicklink = this.el.body;
    RM.L(window, "a", "load", () => {
      import("quicklink").then(function (module) {
        t.quicklink = module.default;
      });
    });
  },
  initQuicklink() {
    if (!this.quicklink) {
      return;
    }
    this.quicklink({
      el: this.el.quicklink,
      // origins: [
      //   site_url.replace(/(^\w+:|^)\/\//, '')
      // ], // default to : [location.hostname]
      ignores: [
        /\/api\/?/,
        /\/wp-admin\/?/,
        /\/wp-login\/?/,
        (uri) => uri.includes(".zip"),
        (uri) => uri.includes("#"),
        (uri, elem) => elem.hasAttribute("noprefetch"),
      ],
    });
  },

  // When Reduced Motion is enabled on browser
  initReducedMotion() {
    // Videos
    const videos = Array.from(document.querySelectorAll("video"));
    if (window.matchMedia("(prefers-reduced-motion)").matches) {
      videos.forEach((video) => {
        video.removeAttribute("autoplay");
        video.pause();
      });
    }
  },

  // Increase the counter on homepage
  initProdTotale() {
    var prodEl = RM.Select.query(".chiffres--production .chiffres__item__nb");
    var prodTotale = parseInt(prodEl.dataset.production) || 0;
    var increment = parseInt(prodEl.dataset.productionNb) || 10;
    var interval = parseInt(prodEl.dataset.productionInterval) || 500;
    var timer = window.rInterval(() => {
      prodTotale += increment;
      prodEl.innerHTML = Util.number_format(prodTotale, 0, ".", " ");
    }, interval);
  },

  // Scroll more click
  initScrollMoreClick() {
    document
      .querySelector(".scroll-more")
      .addEventListener("click", function () {
        window.scrollBy({
          top: window.innerHeight,
          behavior: "smooth",
        });
      });
  },

  // check for SW support and register
  initServiceWorker() {
    // if ('serviceWorker' in navigator) {
    //   const t = this
    //   // const scope = '/';
    //   const scope = '/Lab/quatuor-nebula/'
    //   // Delay registration until after the page has loaded, to ensure that our
    //   // precaching requests don't degrade the first visit experience.
    //   // See https://developers.google.com/web/fundamentals/instant-and-offline/service-worker/registration
    //   window.addEventListener('load', function () {
    //     // Your service-worker.js *must* be located at the top-level directory relative to your site.
    //     // It won't be able to control pages unless it's located at the same level or higher than them.
    //     // See https://github.com/slightlyoff/ServiceWorker/issues/468
    //     // navigator.serviceWorker.register(site_url + '/sw.js', { scope: scope }).then(function(reg) {
    //     navigator.serviceWorker.register(site_url + '/sw.js', { scope: scope }).then(function(reg) {
    //       debug('Service Worker registered successfully.')
    //     }).catch(function(e) {
    //       console.error('Error during service worker registration:', e)
    //     })
    //   })
    //   // Detect if site launch via PWA
    //   if (
    //     window.matchMedia('(display-mode: standalone)').matches ||
    //     window.navigator.standalone === true // for Safari
    //   ) {
    //     console.log('display-mode is standalone');
    //   }
    //   // // And same in CSS
    //   // @media all and (display-mode: standalone) {
    //   //   body {
    //   //     background-color: yellow;
    //   //   }
    //   // }
    //   let deferredPrompt;
    //   window.addEventListener('beforeinstallprompt', (e) => {
    //     console.log('test from beforeinstallprompt');
    //     // Stash the event so it can be triggered later.
    //     deferredPrompt = e;
    //     // Update UI notify the user they can add to home screen
    //     showInstallPromotion();
    //     // prompt();
    //   });
    //   window.addEventListener('appinstalled', (evt) => {
    //     console.log('PWA installed');
    //   });
    // }
  },

  //--- HOOKS

  onUpdate() {
    // Scroll
    this.scroll.last = RM.Lerp(
      this.scroll.last,
      this.scroll.target,
      this.scroll.ease
    );
    if (
      (this.scroll.target > this.scroll.last &&
        this.scroll.last > this.scroll.target - 0.01) ||
      (this.scroll.target < this.scroll.last &&
        this.scroll.last < this.scroll.target + 0.01)
    ) {
      this.scroll.last = this.scroll.target;
    } else if (this.scroll.last === this.scroll.target) {
      this.scroll.isScrolling = false;
    }

    // Launch onAppUpdate on each modules
    // this.modulesWithScroll.forEach((mod) => this.modules[mod].onAppUpdate());

    requestAnimationFrame(this.onUpdate);
  },

  onScroll(e) {
    this.scroll.isScrolling = true;

    this.scroll.target = this.getScrollY();
    this.scroll.diff = this.scroll.target - this.scroll.last;
    this.scroll.acc = this.scroll.diff / this.bounds.window_w;
    this.scroll.velo = +this.scroll.acc;

    // Scroll Direction
    if (this.scroll.target > this.scroll.last + this.scroll.scrollTreshold) {
      this.scroll.scrollDirection = "down";
      Util.removeClass(this.el.body, CLASSES.scrollingUp);
      Util.addClass(this.el.body, CLASSES.scrollingDown);
    } else if (
      this.scroll.target <
      this.scroll.last - this.scroll.scrollTreshold
    ) {
      this.scroll.scrollDirection = "up";
      Util.removeClass(this.el.body, CLASSES.scrollingDown);
      Util.addClass(this.el.body, CLASSES.scrollingUp);
    }

    // Has Scroll ?
    if (this.scroll.target > this.bounds.appOffsetTop) {
      Util.addClass(this.el.body, CLASSES.hasScroll);
    } else {
      Util.removeClass(this.el.body, CLASSES.hasScroll);
    }

    // Launch onAppScroll on each modules
    this.modulesWithScroll.forEach((mod) => this.modules[mod].onAppScroll());

    // Pointer
    this.modules["Pointer"].run();
  },

  onResize(e) {
    const windowDim = Util.getWindowDimensions();
    this.bounds.window_w = windowDim.width;
    this.bounds.window_h = windowDim.height;
    this.bounds.mainOffsetTop = this.el.main.offsetTop;
    this.bounds.appOffsetTop =
      this.bounds.mainOffsetTop + this.el.app.offsetTop;
    this.bounds.headerH = this.el.header.offsetHeight;

    this.launchModulesFunc("onAppResize");
  },

  //--- HELPERS

  getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop;
  },

  displayLoadProgress() {
    let progress = 0,
      progress_base = 0;
    if (this.loadTotal > 0) {
      progress_base = this.loadProgress / this.loadTotal;
      progress = progress_base * 100;
    }

    // debug(this.loadProgress, this.loadTotal);
    // debug('load progress : ' + progress + '%');

    // this.pageloaderTextPercent.innerHTML = Math.round( progress ) + '%';
    this.el.pageloader.style.setProperty("--weight", `${progress * 10}`);
    this.el.pageloaderProgress.style.transform =
      "scaleX(" + progress_base + ")";
  },

  resetLoadProgress() {
    this.loadTotal = 0;
    this.loadProgress = 0;
    this.el.pageloader.style.setProperty("--weight", "100");
    this.el.pageloaderProgress.style.transform = "scaleX(0)";
  },

  checkAppLoaded() {
    // Update the load progress
    this.displayLoadProgress();

    // is loaded ?
    let isLoaded = true;
    this.modulesToInit.forEach((mod) => {
      if (RM.Is.def(this.modules[mod]) && this.modules[mod].isLoaded) {
      } else {
        isLoaded = false;
      }
    });

    if (isLoaded) {
      this.launchModulesFunc("onAppLoaded");

      const t = this;
      // debug('page init loaded animation');
      Util.removeClass(this.el.body, CLASSES.loading);
      Util.addClass(this.el.main, CLASSES.animation);
      Util.removeClass(this.el.body, "loading-with-delay");

      // console.time('loaded')
      const delay = new RM.Delay((_) => {
        // debug('page loaded');
        Util.addClass(t.el.body, CLASSES.loaded);
        // console.timeEnd('loaded');
        // RM.G.id('pageloader').remove();

        t.launchModulesFunc("onAppLoadedEnded");

        // }, variables.transition_slow + (variables.transition_slow / 2))
      }, variables.transition_slow);
      delay.run();

      // Does a scroll target exist?
      if (this.targetEl) {
        var scrollOffset =
          this.targetEl.getBoundingClientRect().top +
          window.pageYOffset -
          this.bounds.headerH;
        this.baoScrollTo(scrollOffset, null, 500);
      }
    }
  },

  launchModulesFunc(func) {
    for (let key in this.modules) this.modules[key][func]();
  },

  // easeInOutQuad functions http://goo.gl/5HLl8
  easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return (c / 2) * t * t + b;
    }
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  },

  baoScrollTo(to, callback, duration) {
    var t = this;
    var start, change, increment, currentTime;

    function move(amount) {
      document.documentElement.scrollTop = amount;
      document.body.parentNode.scrollTop = amount;
      document.body.scrollTop = amount;
    }

    start =
      document.documentElement.scrollTop ||
      document.body.parentNode.scrollTop ||
      document.body.scrollTop;
    change = to - start;
    increment = 20;
    currentTime = 0;

    duration = typeof duration === "undefined" ? 500 : duration;

    function animateScroll() {
      var val;

      // increment the time
      currentTime += increment;
      // find the value with the quadratic in-out easeInOutQuad function
      val = t.easeInOutQuad(currentTime, start, change, duration);
      // move the document.body
      move(val);
      // do the animation unless its over
      if (currentTime < duration) {
        window.requestAnimationFrame(animateScroll);
      } else if (callback && typeof callback === "function") {
        // the animation is done so lets callback
        callback();
      }
    }
    animateScroll();
  },

  copyright() {
    const style = [
      "color: #fff",
      "background: #ffc308",
      "padding: 4px 8px",
      "border-left: 5px solid #282828",
      "border-right: 5px solid #282828",
    ].join(";");
    debug("%cA creation by Boite à Oeufs 🇫🇷", style);
    debug("%c> Site : https://www.boite-a-oeufs.com", style);
    debug("%c> Twitter : https://twitter.com/BoiteOeufs", style);
    debug("%c> Facebook : https://www.facebook.com/boiteoeufs/", style);

    debug("%c> Design by Julian Camaret", style);
    debug("%c> Twitter : https://twitter.com/Jus_motion", style);

    debug("%cDevelopment by Romain Murschel", style);
    debug("%c> Site : https://romainmurschel.fr", style);
    debug("%c> Twitter : https://twitter.com/balthorg", style);
  },
};

window.App = App;

// Kick shit off
App.initialize();

// If the cache is loaded via bfcache (back/forward cache)
// https://web.dev/bfcache/
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    debug("This page was restored from the bfcache.");
    App.initialize();
  } else {
    // console.log('This page was loaded normally.');
  }
});

/* ----------------------------------------------------------------------
  Scroll to anchor
------------------------------------------------------------------------ */

var scrollAnchor = {
  init: function () {
    // Scroll to anchor
    this.scrollToAnchor();

    // // Scroll to element
    // this.scrollToElement();
  },

  // Scroll to anchor
  scrollToAnchor: function () {
    // On page load
    var location_anchor = window.location.hash;
    if (location_anchor.indexOf("#") === 0) {
      console.log(location_anchor);
      var target = document.querySelector(location_anchor);
      console.log("target", target);

      // Does a scroll target exist?
      if (target) {
        // Determine offset

        var adminBar = document.querySelector("#wpadminbar");

        var originalOffset =
          target.getBoundingClientRect().top + window.pageYOffset;
        var scrollOffset = originalOffset;

        if (adminBar) {
          scrollOffset = scrollOffset - adminBar.getBoundingClientRect().height;
        }

        scrollOffset = scrollOffset - App.bounds.headerH;

        console.log("should scroll to", scrollOffset);

        App.baoScrollTo(scrollOffset, null, 1000);
      }
    }

    var anchorElements = document.querySelectorAll('a[href*="#"]');
    var anchorElementsList = Array.prototype.slice.call(anchorElements);
    anchorElementsList = anchorElementsList.filter(function (element) {
      if (
        element.href === "#" ||
        element.href === "#0" ||
        element.id === "cancel-comment-reply-link" ||
        element.id === "cn-accept-cookie" ||
        element.classList.contains("do-not-scroll") ||
        element.classList.contains("screen-reader-shortcut") ||
        element.classList.contains("skip-link")
      ) {
        return false;
      }
      return true;
    });

    anchorElementsList.forEach(function (element) {
      element.addEventListener("click", function (event) {
        var target,
          scrollOffset,
          originalOffset,
          adminBar,
          scrollSpeed,
          additionalOffset;

        // On-page links
        if (
          window.location.hostname === event.target.hostname ||
          event.target.hostname === undefined
        ) {
          // Figure out element to scroll to
          // target = window.location.hash !== '' && document.querySelector( window.location.hash );
          // target = target ? target : event.target.hash !== '' && document.querySelector( event.target.hash );
          target =
            event.target.hash !== "" &&
            document.querySelector(event.target.hash);

          // Does a scroll target exist?
          if (target) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();

            // delete hash so the page won't scroll to it
            window.location.hash = "";

            // Get options
            additionalOffset = event.target.dataset.additionalOffset;
            scrollSpeed = event.target.dataset.scrollSpeed
              ? event.target.dataset.scrollSpeed
              : 500;

            // Determine offset

            adminBar = document.querySelector("#wpadminbar");

            originalOffset =
              target.getBoundingClientRect().top + window.pageYOffset;
            scrollOffset = additionalOffset
              ? originalOffset + additionalOffset
              : originalOffset;

            if (adminBar && event.target.className === "to-the-top") {
              scrollOffset =
                scrollOffset - adminBar.getBoundingClientRect().height;
            }

            scrollOffset = scrollOffset - App.bounds.headerH;

            App.baoScrollTo(scrollOffset, null, scrollSpeed);

            // window.location.hash = event.target.hash.slice( 1 );
          }
        }
      });
    });
  },

  // Scroll to element
  scrollToElement: function () {
    var scrollToElement = document.querySelector("*[data-scroll-to]");

    if (scrollToElement) {
      scrollToElement.addEventListener("click", function (event) {
        var originalOffset,
          additionalOffset,
          scrollOffset,
          scrollSpeed,
          // Figure out element to scroll to
          target = event.target.dataset.baoScrollTo;

        // Make sure said element exists
        if (target) {
          event.preventDefault();

          // Get options
          additionalOffset = event.target.dataset.additionalOffset;
          scrollSpeed = event.target.dataset.scrollSpeed
            ? event.target.dataset.scrollSpeed
            : 500;

          // Determine offset
          originalOffset =
            target.getBoundingClientRect().top + window.pageYOffset;
          scrollOffset = additionalOffset
            ? originalOffset + additionalOffset
            : originalOffset;

          App.baoScrollTo(scrollOffset, null, scrollSpeed);
        }
      });
    }
  },
}; // scrollAnchor
scrollAnchor.init();
